module.exports = __webpack_public_path__ + "static/programmer-d4092dcd3b71d99387d646fccafecf8b.jpg";